<div class="mt-2">
  <cap-content-header>
    <cap-title>
      {{ "vergleichGbPersonZpvPerson" | translate }}
    </cap-title>
  </cap-content-header>
  @if (listLoader) {
    <ng-container>
      @if (initialized) {
        <cap-list-loader [listLoader]="listLoader" [showTotal]="false" class="externe-daten-last-column">
          <div class="cap-list-loader-content">
            <table class="cap-table-detail">
              <thead>
                <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
              </thead>
              <tbody>
                <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
              </tbody>
            </table>
          </div>
        </cap-list-loader>
      }
    </ng-container>
    <ng-template #tableHeaders>
      <tr>
        <th style="width: 40%"></th>
        <th style="width: 30%">{{ "Grundbuchperson" | translate }}</th>
        <th style="width: 30%">{{ "ZPV-person" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template #tableRows>
      @for (item of listLoader?.items; track item) {
        <tr>
          <td>
            {{ item.titel | translate }}
          </td>
          <td>
            @if (showPersonendaten(personGbMaster.hasAuskunftssperre)) {
              @if (item.gbPersonNaviegierbar && item.valueGbPerson) {
                <cap-link
                  [queryParams]="{ id: personGbMaster?.id?.id, versionId: personGbVersion?.id?.id }"
                  [target]="navTargets.NAV_PERSON_GB">
                  <ng-template [ngTemplateOutlet]="valueGbPerson"></ng-template>
                </cap-link>
              } @else {
                @if (item.valueGbPerson) {
                  {{ item.valueGbPerson }}
                } @else {
                  <span>{{ "NotAvailable" | translate }}</span>
                }
              }
              <ng-template #valueGbPerson>
                @if (item.valueGbPerson) {
                  {{ item.valueGbPerson }}
                } @else {
                  <span>{{ "NotAvailable" | translate }}</span>
                }
              </ng-template>
            } @else {
              @if (hasAuskunftsperre(personGbMaster.hasAuskunftssperre) && !hasPermission) {
                <span style="font-style: italic">
                  {{ "stammperson-auskunftsperre" | translate }}
                </span>
              }
            }
          </td>
          <td>
            @if (item.zpvPersonNaviegierbar && item.valueZpvPerson) {
              <cap-link
                [params]="[zpvPerson.fremdId]"
                [target]="navTargets.NAV_PERSON_ZPV"
                [tooltipParams]="{ person: zpvPerson.bezeichnung }">
                <ng-template [ngTemplateOutlet]="valueZpv"></ng-template>
              </cap-link>
            } @else {
              @if (item.valueZpvPerson) {
                {{ item.valueZpvPerson }}
              } @else {
                <span>{{ "NotAvailable" | translate }}</span>
              }
            }
            <ng-template #valueZpv>
              @if (item.valueZpvPerson) {
                {{ item.valueZpvPerson }}
              } @else {
                <span>{{ "NotAvailable" | translate }}</span>
              }
            </ng-template>
          </td>
        </tr>
      }
      <tr>
        <td>
          {{ "Adresse" | translate }}
        </td>
        <td>
          @if (hasAdresssperre(personStamm.auskunftsperre) && !hasPermissionAdresse) {
            <span style="font-style: italic">
              {{ "stammperson-adresssperre" | translate }}
            </span>
          }
          @if (personStamm?.adressen?.length > 0 && showAdressen(personStamm.auskunftsperre)) {
            @for (entry of personStamm?.adressen; track entry) {
              <cap-kompakt-personenadresse
                [auskunftsperre]="personStamm.auskunftsperre"
                [entry]="personStamm?.version"
                [item]="entry"
                style="display: block"></cap-kompakt-personenadresse>
            }
          }
        </td>
        <td>
          @if (zpvPerson?.adressen[0]) {
            <cap-kompakt-personenadresse [entry]="zpvPerson" [item]="zpvPerson?.adressen[0]"></cap-kompakt-personenadresse>
          }
        </td>
      </tr>
    </ng-template>
  }
</div>
